import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import STRSARManagement from './components/STRSARManagement';
import HighRiskCorridorOversight from './components/HighRiskCorridorOversight';
import CaseOutcomesAudit from './components/CaseOutcomesAudit';
import RiskAppetiteMonitoring from './components/RiskAppetiteMonitoring';

const RegulatoryReportingCenter = () => {
  const navigate = useNavigate();
  const [user] = useState({
    id: 'admin-001',
    name: 'Sarah Johnson',
    email: 'sarah.johnson@moneytransfer.com',
    role: 'admin'
  });

  const [activeTab, setActiveTab] = useState('str-sar');

  const handleLogout = () => {
    navigate('/login');
  };

  const tabs = [
    { id: 'str-sar', label: 'STR/SAR Management', icon: 'FileWarning' },
    { id: 'corridors', label: 'High-Risk Corridors', icon: 'MapPin' },
    { id: 'outcomes', label: 'Case Outcomes & Audit', icon: 'ClipboardCheck' },
    { id: 'risk-appetite', label: 'Risk Appetite Monitoring', icon: 'TrendingDown' }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header user={user} onLogout={handleLogout} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-foreground">Regulatory Reporting Center</h1>
              <p className="text-muted-foreground mt-2">
                Comprehensive regulatory compliance and reporting management
              </p>
            </div>
            <button
              onClick={() => navigate('/admin-dashboard')}
              className="flex items-center space-x-2 px-4 py-2 border border-border rounded-lg hover:bg-muted/50 transition-colors"
            >
              <Icon name="ArrowLeft" size={20} />
              <span>Back to Dashboard</span>
            </button>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="bg-card border border-border rounded-lg mb-6">
          <div className="flex overflow-x-auto">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center space-x-2 px-6 py-4 font-medium transition-colors whitespace-nowrap
                  ${activeTab === tab?.id
                    ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted/30'
                  }`}
              >
                <Icon name={tab?.icon} size={20} />
                <span>{tab?.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="space-y-6">
          {activeTab === 'str-sar' && <STRSARManagement />}
          {activeTab === 'corridors' && <HighRiskCorridorOversight />}
          {activeTab === 'outcomes' && <CaseOutcomesAudit />}
          {activeTab === 'risk-appetite' && <RiskAppetiteMonitoring />}
        </div>
      </main>
    </div>
  );
};

export default RegulatoryReportingCenter;